import React, { Component } from 'react';
import './WidgetTitle.css'

export default class WidgetTitle extends Component {
    render() {
        return (
            <div className="WidgetTitle">
                <div className="vbar" />
                {this.props.content}
            </div>
        );
    }
}